import React from 'react';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';

export default function MinimalFooter() {
  return (
    <footer style={footerStyle}>
      <div style={lineStyle} />
      <div style={contentStyle}>
        <span style={copyrightStyle}>
          © {new Date().getFullYear()} Tribe LLC. All rights reserved.
        </span>
        <div style={socialIconsStyle}>
        
          <a href="https://www.instagram.com/jointribe.io/#" style={iconLinkStyle}>
            <FaInstagram style={iconStyle} />
          </a>
   
          <a href="https://www.linkedin.com/company/82302259" style={iconLinkStyle}>
            <FaLinkedin style={iconStyle} />
          </a>
        </div>
      </div>
    </footer>
  );
}

const footerStyle = {
  padding: '12px 20px',
  backgroundColor: '#fff',
  fontFamily: "'Open Sans', sans-serif",
  fontSize: '0.75rem',
  color: '#555',
};

const lineStyle = {
  height: '1px',
  backgroundColor: '#eee',
  marginBottom: '12px',
  marginLeft: '-20px',
  marginRight: '-20px',
};

const contentStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const copyrightStyle = {
  whiteSpace: 'nowrap',
};

const socialIconsStyle = {
  display: 'flex',
  gap: '12px',
};

const iconLinkStyle = {
  color: '#555',
  textDecoration: 'none',
};

const iconStyle = {
  fontSize: '1rem',
};
